import { cn } from "@roman/shared/utils";

export const SelectionBadge = ({
  type,
  maxNumEntriesPerUser,
  showMaxEntries,
}: {
  type: string;
  maxNumEntriesPerUser: number | null;
  showMaxEntries: boolean;
}) => {
  const description = type === "Round0002" ? "初級者" : "中級者";
  const textColor = type === "Round0002" ? "text-light-green" : "text-orange";
  const bgColor = type === "Round0002" ? "bg-light-green" : "bg-orange";
  const borderColor = type === "Round0002" ? "border-[#74BC00]" : "border-[#FF7300]";

  return (
    <div className="absolute top-[5px] right-[5px] flex flex-row-reverse whitespace-nowrap items-center gap-[2px]">
      <div className={cn("flex rounded-full text-white items-center w-full border border-solid", borderColor)}>
        <div className={cn("relative flex justify-center bg-white rounded-l-full w-1/2 ", textColor)}>
          <span className="py-[2px] font-bold text-center text-[10px] leading-[12px] px-4">
            {type === "Round0002" ? "5" : "11"}人制
          </span>
          <div
            className="bg-white absolute -right-[5px]"
            style={{
              clipPath: "polygon(0 0, 100% 0, 0% 100%, 0 100%)",
              width: 12,
              height: "100%",
              zIndex: 1,
            }}
          />
        </div>

        <div
          className={cn(
            "relative flex justify-center pl-2 pr-4 text-[9px] leading-[12px] font-bol rounded-r-full w-1/2 text-center",
            bgColor,
          )}
        >
          <span className="py-[2px] font-bold text-center text-[9px] leading-[12px]">{description}</span>
          <div className={cn("absolute -left-[6px] w-[12px] h-full", bgColor)} />
        </div>
      </div>
      {showMaxEntries && (
        <div className="flex justify-center items-center h-full">
          <div className="relative inline-flex overflow-hidden rounded-full text-white shadow-md bg-primary border border-primary">
            <div className="relative px-2 font-bold bg-white rounded-full text-center text-primary text-blue-500 text-[10px] leading-[16px]">
              エントリー：{maxNumEntriesPerUser}回まで
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
